import React from "react";
import { Typography, Button, Dialog, DialogContent, DialogActions } from "@mui/material";

import theme from "../theme";

interface DialogBoxBiometricDisableProps {
  open: boolean;
  /** Display label of the biometric method, e.g. "Face ID" or "Biometrics". */
  methodName: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const createStyles = () => ({
  header: {
    color: theme.palette.primary.main,
    marginBottom: "10px",
  },
  dialogBox: {
    width: "380px",
  },
});

/**
 * Confirmation shown before turning off biometric (Face ID / fingerprint)
 * sign-in for this device. Confirming revokes the device key server-side so the
 * cold-launch fast-path can no longer be used.
 */
const DialogBoxBiometricDisable: React.FC<DialogBoxBiometricDisableProps> = (props) => {
  const classes = createStyles();
  const trailingText = props.methodName.toLowerCase().includes("fingerprint") ? " Unlock" : "";

  return (
    <Dialog
      open={props.open}
      onClose={props.onCancel}
      maxWidth={"md"}
      aria-labelledby="biometric-disable-dialog-title"
      sx={{ paper: classes.dialogBox }}
    >
      <DialogContent>
        <Typography variant="h4" sx={classes.header}>
          Disable {props.methodName} {trailingText}?
        </Typography>
        <Typography>
          You&apos;ll need to sign in with your password next time. You can turn {props.methodName} {trailingText} back on later.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={props.onCancel} variant="outlined" color="primary" disabled={props.loading}>
          Cancel
        </Button>
        <Button onClick={props.onConfirm} variant="contained" color="primary" disabled={props.loading}>
          {props.loading ? "Disabling..." : "Disable"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogBoxBiometricDisable;
